const MobileSort = () => {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18">
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <g>
            <path
              d="M7 0c-.272 0-.544.103-.752.309L.312 6.199C-.357 6.863.117 8 1.065 8h11.872c.947 0 1.421-1.137.752-1.8L7.752.308C7.544.103 7.272 0 7 0zM1.064 10c-.947 0-1.42 1.137-.75 1.8l5.934 5.891c.415.412 1.089.412 1.504 0l5.934-5.89c.669-.664.196-1.801-.75-1.801H1.064z"
              transform="translate(-283 -315) translate(283 315)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export { MobileSort };
